import PT from 'prop-types';
import { Pill, enums, Icon, utils as u } from 'edrolo-ui';
import { SpicinessLevel } from './SpicinessLevel';
import { WorkingPath } from './WorkingPath';
import style from './styles.scss';

export const QuestionMetadata = ({
  marks,
  spicinessLevel,
  workingPathways,
  skill,
}) => {
  return (
    <div className={style.metadata} data-test="questionMetadata">
      {marks > 0 && (
        <Pill
          variant={enums.PillVariant.OUTLINE}
          color={enums.ColorTheme.PRIMARY}
        >
          {marks === 1 ? `${marks} mark` : `${marks} marks`}
        </Pill>
      )}

      {spicinessLevel && <SpicinessLevel spiciness={spicinessLevel} />}
      {workingPathways && <WorkingPath workingPathways={workingPathways} />}

      {skill && (
        <Pill
          variant={enums.PillVariant.OUTLINE}
          color={enums.ColorTheme.PRIMARY}
        >
          <Icon name="skill" className={u.mr2} />
          {skill.name}
        </Pill>
      )}
    </div>
  );
};

QuestionMetadata.propTypes = {
  marks: PT.number,
  spicinessLevel: PT.number,
  workingPathways: PT.arrayOf(PT.number),
  skill: PT.bool,
};
